module.exports = __webpack_public_path__ + "img/a11.4c063b8c.jpg";